import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { Title } from 'components/layout'
import { Textarea, Checkbox, Select } from 'components/fields'
import { Button } from 'components/misc'
import { form } from 'helpers/decorators'
import { ACTIVITY_SECTIONS, LEVELS } from 'constants/enums'
import get from 'lodash/get'
import { validate } from './validate'


@form({
  form: 'taskReturn',
  validate
})
class TaskReturn extends Component {
  static propTypes = {
    id: PropTypes.number.isRequired,
    handleSubmit: PropTypes.func,
    modal: PropTypes.func.isRequired,
    handleDismiss: PropTypes.func,
    withOptions: PropTypes.bool,
    returnTask: PropTypes.func.isRequired,
    title: PropTypes.string,
    awardLevel: PropTypes.object,
    intlKey: PropTypes.string,
    noNote: PropTypes.bool,
    deletionReasons: PropTypes.bool,
    showReasons: PropTypes.bool,
    negative: PropTypes.bool,
    ctaIntlKey: PropTypes.string,
    isAssessorManagementEnabled: PropTypes.bool,
    codeLists: PropTypes.object.isRequired
  }

  static defaultProps = {
    title: 'Revise',
    intlKey: 'tasks.revise_item'
  }

  handleDismiss = () => {
    if (this.props.handleDismiss) {
      this.props.handleDismiss()
    } else {
      this.props.modal(null)
    }
  }

  render() {
    const {
      handleSubmit,
      returnTask,
      id,
      title,
      intlKey,
      noNote,
      deletionReasons,
      negative,
      ctaIntlKey,
      withOptions,
      awardLevel,
      isAssessorManagementEnabled,
      codeLists,
      showReasons
    } = this.props

    const assessorDeletionReasons = get(codeLists, 'assessorReasonsOfDeletionTypes.list', [])

    const activityReasons = get(codeLists, 'activityReviseReasons.list', [])

    const showReasonsCombobox = isAssessorManagementEnabled && (showReasons || deletionReasons)

    return (
      <form onSubmit={handleSubmit(fields => returnTask(id, fields))}>
        <h2 className="text--center">
          <FormattedMessage id={intlKey} defaultMessage={title} />?
        </h2>
        {!noNote && <Textarea name="note" label="Reason" intlKey="label.reason_of_revise" />}
        {showReasonsCombobox && <div >
          <Select
              label={deletionReasons ? 'Reason for deletion' : 'Action Required'}
              intlKey={deletionReasons ? 'label.reason_of_deletion' : 'label.action_required'}
              name="reason"
              options={deletionReasons ? assessorDeletionReasons : activityReasons}
          />
        </div>}

        {deletionReasons && (
          <Title h4 intlKey="moduleTitle.if_you_delete_this_registration">
            If you delete this registration the activity will be moved back to Setup, are you sure?
          </Title>)}

        {withOptions && (
          <div className="base-margin--bottom">
            <Title h3 intlKey="moduleTitle.which_section_do_you_want_to">
              Which section do you want to return to 'In progress'?
            </Title>
            {ACTIVITY_SECTIONS.list.map(item => (
              <Checkbox
                key={item.value}
                label={item.label}
                disabled={
                  item.value === ACTIVITY_SECTIONS.rp.id &&
                  awardLevel.value !== LEVELS.GOLD.value
                }
                intlKey={item.intlKey}
                name={item.value}
              />
            ))}
          </div>
        )}

        <div className="row">
          <div className="col-xs-6">
            <Button
              type="button"
              intlKey="button.dismiss"
              secondary
              onClick={this.handleDismiss}
            >
              Dismiss
            </Button>
          </div>
          <div className="col-xs-6 text--right">
            <Button negative={negative} intlKey={ctaIntlKey || 'button.revise'}>Revise</Button>
          </div>
        </div>
      </form>
    )
  }
}

export default TaskReturn
